// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "about" + "." + "8a7c1c2a07ea5ee0" + ".js?v=1788609167102";
};